import Vue from "vue";
import Vuesax from "vuesax";
import "vuesax/dist/vuesax.css"; //Vu

Vue.use(Vuesax, {
  // options here
});
// end vuesax
